function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0V1.55556H1.55556V2.60069C1.55556 3.63166 1.96485 4.62121 2.69488 5.35026L4.34462 7L2.69488 8.64974C1.96485 9.37879 1.55556 10.3683 1.55556 11.3993V12.4444H0V14H10.8889V12.4444H9.33333V11.3993C9.33333 10.3684 8.92303 9.37875 8.19401 8.64974L6.54427 7L8.19401 5.35026C8.92361 4.62066 9.33333 3.63166 9.33333 2.60069V1.55556H10.8889V0H0ZM3.11111 1.55556H7.77778V2.60069C7.77778 3.06299 7.64042 3.50963 7.38889 3.88889H3.5C3.24806 3.50995 3.11111 3.06345 3.11111 2.60069V1.55556ZM5.44444 8.09983L7.09418 9.74957C7.53184 10.1872 7.77778 10.7813 7.77778 11.3993V12.4444H3.11111V11.3993C3.11111 10.7798 3.35651 10.1887 3.7947 9.75109L5.44444 8.09983Z",
  fill: "white"
});

var SvgHourglass = function SvgHourglass(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHourglass, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hourglass.acd62ced.svg";
export { ForwardRef as ReactComponent };